import { FontType } from './types';
import styles from './Typography.module.scss';

export const getTypographyVariantClass = (variant: FontType = 'p3') => {
    return styles[`typography--${variant}`];
};
